import * as R from 'ramda';

export const getParamOr = (defaultResponse, searchParams) =>
  R.pathOr(defaultResponse, ['state', 'params', searchParams]);

export const setParam = (navigation, paramName, value) =>
  navigation.setParams({ [paramName]: value });

export const getParams = R.pathOr(null, ['state', 'params']);
